import { FC, Fragment } from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { dateFormat } from 'utils/dynamic/i18n';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TicketRouteTimeProps {
  dateTime: string;
  airportDesc: string;
  airport: string;
  arrivalDaysDifference?: number;
  highlighted?: boolean;
  isShort?: boolean;
}

const TicketRouteTime: FC<TicketRouteTimeProps> = ({
  dateTime,
  airportDesc,
  airport,
  ...props
}) => {
  return (
    <div className="ticket-time">
      <div className="ticket-time-inner">
        <span className="date">{dateFormat(dateTime, 'MMM dd, yyyy')}</span>
        <span>
          <span
            dangerouslySetInnerHTML={{
              __html: dateFormat(
                dateTime,
                "'<span class=''week''>'EEE' - </span><span class=''text-bold''>'HH:mm'</span>'"
              ),
            }}
          ></span>
          {!!props.arrivalDaysDifference && (
            <span className="color-danger ml-4">+{Math.ceil(props.arrivalDaysDifference)}</span>
          )}
        </span>
        <span className="airport">
          {props.isShort ? (
            <Tooltip
              content={airportDesc}
              children={
                <span className={'text-bold' + (props.highlighted ? ' color-danger' : '')}>
                  {airport}
                </span>
              }
            />
          ) : (
            <Fragment>
              <span className={'text-bold' + (props.highlighted ? ' color-danger' : '')}>
                {airport}
              </span>{' '}
              <span className="airport-desc">- {airportDesc}</span>
            </Fragment>
          )}
        </span>
      </div>
    </div>
  );
};

export default withErrorBoundary(TicketRouteTime, 'TicketRouteTime');
